// src/components/TeachingPlanCard/Journey2DCard.js
import React, { forwardRef, useMemo } from "react";
import { Box, Typography, Tooltip } from "@mui/material";

const Journey2DCard = forwardRef(({ mlu, stepIndex, config, fullCatalog }, ref) => {
    // Look up the full MLU details by code to get eqf and outcome
    const fullMlu = useMemo(() => {
        return (fullCatalog || []).find((item) => item.id === mlu.code) || {};
    }, [fullCatalog, mlu.code]);

    const tooltipContent = (
        <Box sx={{ maxWidth: 320, p: 0.5 }}>
            <Typography variant="caption" display="block">
                <strong>ID:</strong> {mlu.code}
            </Typography>
            {(fullMlu.title || mlu.title) && (
                <Typography variant="caption" display="block">
                    <strong>Title:</strong> {fullMlu.title || mlu.title}
                </Typography>
            )}
            {fullMlu.eqf && (
                <Typography variant="caption" display="block">
                    <strong>EQF:</strong> {fullMlu.eqf}
                </Typography>
            )}
            {fullMlu.outcome && (
                <Typography variant="caption" display="block" sx={{ mt: 0.5 }}>
                    <strong>Learning outcome:</strong> {fullMlu.outcome}
                </Typography>
            )}
        </Box>
    );

    return (
        <Tooltip title={tooltipContent} arrow placement="top">
            <Box
                ref={ref}
                sx={{
                    display: "flex",
                    alignItems: "center",
                    width: "100%",
                    maxWidth: "200px",
                    p: 1,
                    borderRadius: 2,
                    bgcolor: config.bg,
                    border: "1px solid",
                    borderColor: config.main,
                    boxShadow: `0px 2px 4px rgba(0,0,0,0.05)`,
                    position: "relative",
                    zIndex: 2, // Ensure it sits above SVG lines
                    cursor: "pointer",
                    transition: "all 0.2s ease-in-out",
                    "&:hover": {
                        transform: "translateY(-2px)",
                        boxShadow: `0px 4px 8px rgba(0,0,0,0.1)`,
                    }
                }}
            >
                {/* Sequence number */}
                <Box
                    sx={{
                        flexShrink: 0,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: 24,
                        height: 24,
                        borderRadius: "50%",
                        bgcolor: config.main,
                        color: config.id === "EID" ? "#000" : "#fff",
                        fontSize: "0.75rem",
                        fontWeight: 700,
                        mr: 1,
                        boxShadow: `0px 2px 2px rgba(0,0,0,0.2)`,
                    }}
                >
                    {stepIndex}
                </Box>

                {/* Title block */}
                <Box sx={{ minWidth: 0 }}>
                    <Typography
                        variant="caption"
                        sx={{
                            display: "block",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            color: "text.primary",
                            fontWeight: 600,
                            lineHeight: 1.2,
                            fontSize: "0.75rem",
                            wordWrap: "break-word",
                            // Use standard absolute max-height rather than webkit-clamp for html2canvas compatibility
                            maxHeight: "2.4em",
                        }}
                    >
                        {fullMlu.title || mlu.title || mlu.code}
                    </Typography>
                </Box>
            </Box>
        </Tooltip>
    );
});

export default Journey2DCard;
